import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { toast } from "react-toastify";
import { loginWithToken } from "../../../services/security-services/SecurityActions";
import { resolvePostLoginRoute } from "../../../services/tenant-services/tenantActions";
import "./SsoCallback.css";

export default function SsoCallback() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token");
    const error = searchParams.get("error");
    const message = searchParams.get("message");

    // Handle errors from backend
    if (error) {
      const errorMessage = message || getErrorMessage(error);
      toast.error(errorMessage);
      navigate("/login");
      return;
    }

    // Handle successful authentication
    if (token) {
      localStorage.setItem("token", token);
      dispatch(loginWithToken(token));
      // Multi-tenant users pick a tenant first; everyone else goes straight in.
      resolvePostLoginRoute("/office/global").then((route) => navigate(route));
    } else {
      // No token and no error - redirect to login
      navigate("/login");
    }
  }, [dispatch, location, navigate]);

  const getErrorMessage = (error) => {
    switch (error) {
      case "user_not_found":
        return t('ssoCallbackPage.errors.userNotFound') || "User not registered. Please contact your administrator.";
      case "account_inactive":
        return t('ssoCallbackPage.errors.accountInactive') || "Account is inactive. Please contact your administrator.";
      default:
        return t('ssoCallbackPage.errors.generic') || "Authentication failed. Please try again.";
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="text-center">
        <div className="spinner-border text-primary mb-4" style={{ width: "3rem", height: "3rem" }} role="status">
          <span className="visually-hidden">{t('ssoCallbackPage.loading')}</span>
        </div>
        <h4 className="mb-2">{t('ssoCallbackPage.title')}</h4>
        <p className="text-muted">{t('ssoCallbackPage.subtitle')}</p>
      </div>
    </div>
  );
}
